export const echoTool = {
    tool: {
        name: 'echo',
        description: 'Echoes back the input payload exactly as received',
        inputSchema: {
            type: 'object',
            properties: {
                payload: {
                    type: 'string',
                    description: 'The payload to echo back',
                },
            },
            required: ['payload'],
        },
    },
    execute: async (args) => {
        if (!args.payload || typeof args.payload !== 'string') {
            throw new Error("Echo tool requires a 'payload' parameter of type string");
        }
        return { content: [{ type: 'text', text: args.payload }] };
    },
};
